import { Autocomplete, Box, Button, TextField, } from '@mui/material';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import GlobalDialogContent from '../GlobalDialogContent';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../redux/store';
import { closeDialog } from '../../../redux/reducer/dialogSlice';
import { RoleListService, UpdateHospitalUserStatus, UpdateUserStatusService } from '../../../utils/services/registration/donor-registration.service';
import { showSnackbar } from '../../../redux/reducer/snackbarSlice';
import { setModuleRefresh } from '../../../redux/reducer/registration/RefreshSlice';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function UserApprovalDialog() {
    const dispatch = useDispatch();
    const { status, payload } = useSelector((state: RootState) => state.dialog);
    const uuid = payload?.uuid;
    const registrationType = payload?.registrationType;
    const [searchParams] = useSearchParams();
    const type = searchParams.get("type");
    const [selectedRoleId, setSelectedRoleId] = useState<string>('');
    const [roleList, setRoleList] = useState<any>([]);
    const authUser = useSelector((state: RootState) => state.authUser);
    const [loading, setloading] = useState(false);

    const validationSchema = Yup.object().shape({
        comments: Yup.string().required('Comments are required'),
        role: Yup.lazy((value) => {
            return payload?.registrationType === "government_user" && status !== "Compliance" && status !== "Rejected"
                ? Yup.string().required('Role is required')
                : Yup.string().notRequired();
        }),
    });

    const fetchRoles = async () => {
        const payload = {
            limit: 99,
            offset: 0,
        };
        const { data, code } = await RoleListService(payload);
        if (code === 200 && data) {
            const GovRoles = data?.data?.filter(
                (item: any) => item.user_type === "cmrf_department" || item.user_type === "csr_cell" || item.user_type === "government_user"
            );
            const DonorRoles = data?.data?.filter(
                (item: any) => item.user_type === "donor"
            );
            const AgnecyRoles = data?.data?.filter(
                (item: any) => item.user_type === "implementing_agency"
            );
            const HospitalRoles = data?.data?.filter(
                (item: any) => item.user_type === "hospital"
            );
            if (type === 'government_user') {
                setRoleList(GovRoles);
            } else if (type === 'donor') {
                setRoleList(DonorRoles);
            } else if (type === 'implementing_agency') {
                setRoleList(AgnecyRoles);
            }
            else if (type === 'hospital') {
                setRoleList(HospitalRoles);

            }
            else {
                setRoleList([]);
            }
        }
    };
    return (
        <GlobalDialogContent
            dialogBody={
                <Formik
                    initialValues={{ comments: '', role: '' }}
                    validationSchema={validationSchema}
                    onSubmit={async (values, { setSubmitting }) => {
                        setloading(true);                      
                        const normalizedStatus = status?.toLowerCase();
                        const finalStatus = normalizedStatus === 'approve' ? 'approved': normalizedStatus === 'compliance'? 'compliance' : 'rejected';
                        const submitPayload = {
                            entity_type: registrationType,
                            uuid: uuid,
                            status: finalStatus,
                            updated_by: authUser?.userDetails?.id,
                            comments: values.comments,
                            ...(registrationType === "government_user" && status !== 'Compliance' && { role_id: Number(selectedRoleId) }),
                        };
                        let response;                      
                        if (registrationType === 'hospital') { response = await UpdateHospitalUserStatus(submitPayload);} 
                        else {response = await UpdateUserStatusService(submitPayload);}                      
                        const { code, message } = response;
                        if (code === 200) {
                        dispatch(closeDialog());
                        dispatch(setModuleRefresh({ moduleName: 'user_details', refresh: true }));
                        dispatch(showSnackbar({ type: 'success', message: message || 'Status Updated Successfully' }));
                        } else {
                            setloading(false);
                        dispatch(showSnackbar({ type: 'error', message: message || 'Something went wrong, please try again' }));
                        }
                    }}
                >
                    {({ errors, touched, isSubmitting, setFieldValue }) => (
                        <Form id="user-approval-form">
                            {(status !== 'Compliance' && status !== 'Rejected' && payload?.registrationType === "government_user") && <Box mb={2}>
                                <Autocomplete
                                    onOpen={fetchRoles}
                                    size='small'
                                    options={roleList}
                                    getOptionLabel={(option) => option.name}
                                    value={roleList.find((role: any) => role.id === selectedRoleId) || null}
                                    onChange={(_, newValue) => {
                                        setSelectedRoleId(newValue?.id || '');
                                        setFieldValue('role', newValue?.name || '');
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Assign Role *"
                                            error={touched.role && Boolean(errors.role)}
                                            helperText={touched.role && errors.role}
                                            fullWidth
                                        />
                                    )}
                                />
                            </Box>
                            }
                            <Box mb={2}>
                                <Field
                                    as={TextField}
                                    name="comments"
                                    label="Comments *"
                                    fullWidth
                                    multiline
                                    rows={4}
                                    error={touched.comments && Boolean(errors.comments)}
                                    helperText={touched.comments && errors.comments}
                                />
                            </Box>
                        </Form>
                    )}
                </Formik>
            }
            dialogFooter={
                <Button
                    type="submit"
                    variant="contained"
                    color={status === 'Approve' ? 'success' : status === 'Compliance' ? "secondary" : "error"}
                    form="user-approval-form"
                    disabled={loading}
                >
                    { loading ? 'Loading...' : status}
                </Button>
            }
        />
    );
}